import useEntity from 'recoil/useEntity/useEntity'
import { IProjectType } from '../projectTypes.types'
import projectTypesApi from '../projectTypes.api'
import projectTypesTableAtom from '../components/ProjectTypesTable/projectTypesTable.atom'

const useProjectType = (id: IProjectType['id']) => {
  const { entity, loading } = useEntity({
    atom: projectTypesTableAtom,
    entityId: id,
    itemFetcher: projectTypesApi.getOne,
    resource: 'project-types',
  })

  return { projectType: entity, loading }
}

export default useProjectType
